import { LineOfBusiness } from "../../app/types";

export const MEDICAL_PANEL_DOCUMENT_TYPE = "MEDICAL_PANEL";
export const STATE_FORM_DOCUMENT_TYPE = "STATE_FORM";
export const AUTHORIZATION_FORM_DOCUMENT_TYPE = "AUTHORIZATION_FORM";
export const WC_CLAIM_ATTACHMENT = "WC_CLAIM_ATTACHMENT";
export const CARGO_CLAIM_ATTACHMENT = "CARGO_CLAIM_ATTACHMENT";
export const INTERNATIONAL_PRODUCT_LIABILITY_CLAIM_ATTACHMENT =
  "INTERNATIONAL_PRODUCT_LIABILITY_CLAIM_ATTACHMENT";
export const ATOZ_CLAIM_ATTACHMENT = "ATOZ_CLAIM_ATTACHMENT";
export const MULTIPLE_ITEM_CLAIM_ATTACHMENT_TEMPLATE = "MULTIPLE_ITEM_CLAIM_ATTACHMENT_TEMPLATE";
export const WC_CANADA_PROVINCE_FORM_DOCUMENT_TYPE = "WC_CANADA_PROVINCE_FORM";

export const DOCUMENT_TYPE_LABELS: { [key: string]: string } = {
  [MEDICAL_PANEL_DOCUMENT_TYPE]: "Preferred Provider Panels",
  [STATE_FORM_DOCUMENT_TYPE]: "State Forms",
  [AUTHORIZATION_FORM_DOCUMENT_TYPE]: "Authorization Forms",
  [WC_CANADA_PROVINCE_FORM_DOCUMENT_TYPE]: "Province Forms",
};

export const UPLOAD_BUCKET = {
  [LineOfBusiness.WORKERS_COMPENSATION]: WC_CLAIM_ATTACHMENT,
  [LineOfBusiness.CARGO]: CARGO_CLAIM_ATTACHMENT,
  [LineOfBusiness.IPL]: INTERNATIONAL_PRODUCT_LIABILITY_CLAIM_ATTACHMENT,
  [LineOfBusiness.ATOZ]: ATOZ_CLAIM_ATTACHMENT,
};

// Intake for requests to the US WC team (missing or incorrect medical provider panels,
// for example). Replaced the SIM-T template the team no longer works.
export const US_WC_RIVER_WORKFLOW_URL =
  "https://river.amazon.com/VNC/workflows?buildingType=GRMC&q0=2b7a4e38-c630-42ed-bbc0-1e64fb1a748f&q1=125147e0-91ca-4419-af01-611bd8aca8d9&q2=f74b4a74-d969-4aa5-878b-dd6ea8bd4197&q3=2c439caf-b403-449a-b9f2-285efeca2d43&id=2c439caf-b403-449a-b9f2-285efeca2d43";
